// extracted by mini-css-extract-plugin
export default {"button":"NewOption_button__P5h7M","divider":"NewOption_divider__Syxgy","link":"NewOption_link__Qg1QT","modal":"NewOption_modal__NZUy7","card":"NewOption_card__J7C6M"};